/**
 * Slot entity class
 */

/**
 * SlotFactory
 * returns Slot entity class
 *
 * @class SlotFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.Slot} class
 *
 * @ngdoc factory
 * @name mwApp.factory:SlotFactory
 */
/* @ngInject */
export default function SlotFactory (
  $http,
  Entity,
  FileUploadMixin
) {
  /* === Slot class === */

  /**
   * Slot model
   *
   * @class Slot
   * @classdesc Slot model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing Slot entity fields
   * @return {models.Slot} Slot entity
   */
  function Slot () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  Slot.prototype = Object.create(Entity.prototype)
  Slot.prototype.constructor = Slot

  /* === Slot instance methods & fields === */

  Object.assign(Slot.prototype, {
    /**
     * instance fields
     *
     * @memberof models.Slot#
     * @type {Object}
     */
    _fields: {
      active: Boolean,
      ageRatingId: Number,
      contentId: Number,
      contentSets: ['ContentSet'],
      contentType: String,
      iconUrl: String,
      subscriptions: ['Subscription'],
      title: String
    },

    /**
     * url template
     *
     * @memberof models.Slot#
     * @type {String}
     */
    _urlTemplate: 'api/networks/{{::networkId}}/carousels/shelf/{{::shelfId}}/slots/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.Slot#
     * @type {String}
     */
    _publicUrlTemplate: 'networks/{{::networkId}}/carousels/shelf/{{::shelfId}}/slots/{{::id}}',

    /**
     * Prepare slot
     *
     * @memberof models.Slot#
     * @override
     */
    _prepare: function () {
      this.iconUrl = FileUploadMixin.getPreviewImageUrl(this.iconUrl)
    },

    /**
     * Get underlying object
     *
     * @memberof models.Slot#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      return Entity.prototype._object.apply(this, arguments)
    },

    /**
     * Get preview image URL
     *
     * @memberof models.Slot#
     * @return {String}
     */
    _previewImageUrl: function () {
      // return FileUploadMixin.getPreviewImageUrl(this.iconUrl)
    }
  }, FileUploadMixin)

  /* === Slot static methods & fields === */
  Object.assign(Slot, Entity)
  Slot._name = 'Slot'
  Slot.init()

  // permissions (пример, можно скорректировать)
  Slot.access = {
    // view: 'viewSlot',
    // edit: 'editSlot',
    // create: 'editSlot',
    // delete: 'deleteSlot'
  }

  return Slot
}
